import React from 'react';
import {connect} from 'react-redux';
import './css/Breadcrumbs.styl';

export const Breadcrumbs = props => {
  const {name, location} = props.entity || {};
  const state = location && location.state;
  const city = location && location.city;
  const {description, siteName} = props.affiliate || {};

  const homeDirectory = siteName
    ? {url: `/obituaries/${siteName}`, title: 'Home'}
    : {url: '/', title: 'Home'};
  const funeralHomesDirectory = description
    ? {url: '/funeral-homes/directory', title: `${description} Funeral Homes`}
    : {url: '/funeral-homes', title: 'Funeral Homes'};
  const breadcrumbItems = [homeDirectory, funeralHomesDirectory];

  if (state && city) {
    breadcrumbItems.push(
      {url: `/funeral-homes/directory/${state.urlName}`, title: state.fullName},
      {
        url: `/funeral-homes/directory/${state.urlName}/${city.urlName}`,
        title: city.fullName,
      }
    );
  }

  if (name) {
    breadcrumbItems.push({title: name});
  }

  return (
    <div className="breadcrumbs">
      {breadcrumbItems.map((item, index) => (
        <span
          key={index}
          className="breadcrumb-item"
          itemScope
          itemType="http://data-vocabulary.org/Breadcrumb"
        >
          <a href={item.url} itemProp="url" className="breadcrumb-link">
            <span itemProp="title">{item.title}</span>
          </a>
        </span>
      ))}
    </div>
  );
};

const mapStateToProps = state => ({
  affiliate: state.affiliateStore,
});

export default connect(mapStateToProps)(Breadcrumbs);



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/Breadcrumbs/index.js